import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const createDangerousHtml = (html) => ({ __html: html });

const getBody = ({
  description,
  meta_description,
  body,
}) => {
  let text = "";
    text =
      description && description.snippet !== null
        ? description.snippet
        : meta_description && meta_description.snippet !== null
        ? meta_description.snippet
        : body && body.snippet !== null
        ? body.snippet
        : "";
  

  const res = text.substring(0, 350);
  const pretty =
    text.length !== res.length ? res.substring(0, res.lastIndexOf(" ")) : res;
  return `${pretty} ${pretty.length !== res.length ? "..." : ""}`;
};

const getSection = ({ app, source, discipline }) => {
  if (app === "OSS") {
    if (discipline) {
      return discipline.raw;
    } else {
      return "";
    }
  }
  return source.raw;
};

const getIfDoc = ({ app, filetype }) =>
  app !== "OSS" && filetype && filetype.raw !== "Webpage";

class ListItem extends Component {
  _handleClickLink = (docId, url, title) => (e) => {
    this.props.tClick(this.props.q, docId, this.props.request_id, this.props.facets.source, url, this.props.results, title, () => {
    });
  };

  render() {
    const {
      title,
      filetype,
      url,
      id,
      yearstr,
      gated,
    } = this.props;
    return (
      <div className="result-item-container" key={id.raw}>
        <div className="result-item-text-container">
          <div   className="result-item-title">
          <a
            className="result-item-title-link"
            href={url.raw}
            onClick={this._handleClickLink(id.raw, url.raw, title.raw )}
          >
            {this.props.app !== "OSS" &&
              filetype &&
              filetype.raw !== "Webpage" && (
                <sup className="title-superscript">
                  {" "}
                  [{filetype.raw.toUpperCase()}] &nbsp;
                </sup>
              )}
            {this.props.app === "OSS" && yearstr && yearstr.raw && (
              <sup className="title-superscript">
                {" "}
                [{yearstr.raw && yearstr.raw.toUpperCase()}] &nbsp;
              </sup>
            )}
            {title ? (
              <span dangerouslySetInnerHTML={createDangerousHtml(title.snippet)}
              />
            ) : (
              <span
                dangerouslySetInnerHTML={createDangerousHtml(url.raw)}
              />
            )}
            &nbsp;
            {gated && (gated.raw === "1" || gated.raw === 1) && (
              <FontAwesomeIcon icon="lock" className="result-item-gated-icon" />
            )}
          </a>
          </div>
          <div
            className="result-item-body"
            dangerouslySetInnerHTML={createDangerousHtml(getBody(this.props))}
          />
          <div className="result-item-section-and-url">
            <div
              className="result-item-section-badge"
              dangerouslySetInnerHTML={createDangerousHtml(
                getSection(this.props)
              )}
            />
            <div className="result-item-url">
              <a
                href={url.raw}
                target={getIfDoc(this.props) ? "_blank" : "_self"}
              >
                {url.raw.length > 150
                  ? `${url.raw.substring(0, 147)}...`
                  : url.raw}
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class ResultList extends Component {
  render() {
    return (
      <Fragment>
        {this.props.results.results &&
          this.props.results.results.length > 0 &&
          this.props.results.results.map((i) => (
            <ListItem
              {...i}
              key={i.id.raw}
              q={this.props.q}
              app={this.props.app}
              request_id={this.props.results.meta.request_id}
              results ={this.props.results}
              tClick={this.props.tClick}
              facets={this.props.results.facets}
            />
          ))}
      </Fragment>
    );
  }
}

export default ResultList;
